export const MICRO_FRONTEND_ERRORS = {
    loadComponent: 'MfeLoadComponentError',
};
export class RemoteScriptError extends Error {
    script_type;
    url;
    constructor(message, scriptType, url) {
        super(message);
        this.script_type = scriptType;
        this.url = url;
    }
}
